<template>

  <div class="form-panel">     
    <div class="form-panel__header">
      <h2 class="titulo-h2">Selecciona tu estado civil</h2>
    </div>
    <div class="form-panel__body">     
      <div class="form-fields">
        <div class="form-fields__secundario">
          <div class="form-fields__secundario-iconos">
            <a class="icon-seleccion icon-seleccion-soltero" :class="[estadoCivil != 'S' ? 'grayscale' : 'icon-seleccion-seleccionado', 'icon-seleccion-soltero' + claseSexo]" @click="estadoCivil = 'S'" /> 
            <a class="icon-seleccion icon-seleccion-casado" :class="[estadoCivil != 'C' ? 'grayscale' : 'icon-seleccion-seleccionado', 'icon-seleccion-casado' + claseSexo]" @click="estadoCivil = 'C'" />
            <a class="icon-seleccion icon-seleccion-union-libre" :class="[estadoCivil != 'U' ? 'grayscale' : 'icon-seleccion-seleccionado', 'icon-seleccion-union-libre' + claseSexo]" @click="estadoCivil = 'U'" />
            <a class="icon-seleccion icon-seleccion-divorciado" :class="[estadoCivil != 'D' ? 'grayscale' : 'icon-seleccion-seleccionado', 'icon-seleccion-divorciado' + claseSexo]" @click="estadoCivil = 'D'" />
            <a class="icon-seleccion icon-seleccion-separado" :class="[estadoCivil != 'E' ? 'grayscale' : 'icon-seleccion-seleccionado', 'icon-seleccion-separado' + claseSexo]" @click="estadoCivil = 'E'" />
            <a class="icon-seleccion icon-seleccion-viudo" :class="[estadoCivil != 'V' ? 'grayscale' : 'icon-seleccion-seleccionado', 'icon-seleccion-viudo' + claseSexo]" @click="estadoCivil = 'V'" />
          </div>           
        </div>    
        <div class="form-fields__navegacion"> 
          <a v-if="estadoCivil && estadoCivil != estadoCivilInicial" class="waves-effect waves-light m-btn form-fields__navegacion-der" tabindex="0" @click="guardarEstadoCivil()">Guardar</a>               
        </div> 
      </div>  
    </div>      
  </div>   
</template>

<script>

export default {
  data() {
    return{
      estadoCivilInicial: null,
      estadoCivil: null 
    };
  },
  computed: {
    claseSexo() {
      return this.$store.getters.cliente.sexo == 'F' ? '-F' : '-M'

      switch (this.$store.getters.cliente.sexo)
      {
        case 'F': return '-F'

        case 'M': return '-M'
      }

      return ''
    }
  },
  methods:{
    guardarEstadoCivil() {
      this.$store.dispatch('guardarEstadoCivil', this.estadoCivil)
    }
  },
  created() {
    this.estadoCivilInicial = this.$store.getters.cliente.estadoCivil
    this.estadoCivil = this.estadoCivilInicial
  }
}
</script>